export default __webpack_public_path__ + "static/HES-SO_INTERVIEWS_VALERIE-8490d308a844835e7d22955b3daf0fb8.jpg";